import React from 'react'
import styled from 'styled-components'
import INFTUrl from './INFTUrl'
import { CheckUrl } from '../../utils/CheckUrl'

const NFTURLItem = styled.div`
  text-align: center;
  padding: 0.5rem;
  user-select: none;
  
  .wrapper {
    border-radius: 1rem;
    border: solid 1px ${({ theme }) => theme.yetiBlue};
    padding: 0.5rem 1rem;

    .type {
      font-size: 0.7rem;
      font-weight: 500;
      margin-bottom: 0.5rem;
      color: ${({ theme }) => theme.yetiBlue};
    }

    .name {
      font-size: 0.9rem;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
  }
`
const NFTurl = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.text1};
  font-weight: 500;

  :hover {
    text-decoration: underline;
  }

  :focus {
    outline: none;
    text-decoration: underline;
  }

  :active {
    text-decoration: none;
  }
`

export default function NFTUrl({ name, type }: INFTUrl) {
  return (
    <NFTURLItem className="property-item">
      <div className="wrapper">
        <div className="type" title={type}>
          {type}
        </div>
        <div className="name" title={name}>
          {CheckUrl(name) ? (
            <NFTurl target="_blank" href={name} rel="noreferrer nofollow">
              {name}
            </NFTurl>
          ) : (
            name
          )}
        </div>
      </div>
    </NFTURLItem>
  )
}
